export default {
  getSemaphoreColor: (state) => (val) => {
    if (state.semaphore.green.min === null || state.semaphore.red.max === null) {
      if (val >= 70) return '#8DBF66'
      return '#E64119'
    }
    if (val >= state.semaphore.green.min) return '#8DBF66'
    else if (val >= state.semaphore.amber.min && val <= state.semaphore.amber.max) return state.semaphore.amber.color
    return state.semaphore.red.color
  }
}
